import styled from "styled-components/macro";

export const Title = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 1.2;
  color: #383838;
`;

export const Subtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
`;

export const sidePadding =
  "padding-left: min(28px, 8%); padding-right: min(28px, 8%); @media screen and (max-width:420px) { padding-left: max(20px, 6%); padding-right: max(20px, 6%); }";
